import { Page } from 'shared/Page'

import { BaseLayout } from './BaseLayout'

type DefaultLayoutProps = {
  children: React.ReactNode
}

export const DefaultLayout = ({ children }: DefaultLayoutProps) => {
  return (
    <BaseLayout>
      <Page>
        <Page.Header />
        <Page.Content>{children}</Page.Content>
        <Page.Footer />
      </Page>
    </BaseLayout>
  )
}
